export const RESOURCES = {
  ORGANIZATION: "001",
  AUTH: "002",
  REPORT: "008",
  CONSTRUCTION_SITE: "010",
  ZONE: "011",
  DOCUMENT: "012",
  NOTIFICATION: "014",
  SUB_CONTRACTOR: "015",
  PROFILE: "016",
  USER: "017",
  ADMIN_USER: "017/platform/cms",
  APP_USER: "017/platform/app",
  USER_GROUP: "018",
  ADMIN_USER_GROUP: "018/platform/cms",
  APP_USER_GROUP: "018/platform/app",
  POINT_CATEGORY: "019",
  POINT_ITEM: "020",
  SAFETY_POINT_ITEM: "020/type/safetyPoint",
  REWARD_POINT_ITEM: "020/type/rewardPoint",
  POINT_TRANSACTION: "021",
  SAFETY_POINT: "021/walletType/safetyPoint",
  REWARD_POINT: "021/walletType/rewardPoint",
  WALLET: "022",
  SERVICE: "023",
  SERVICE_END_POINT: "024",
  RISK_REPORT: "026",
  COURSE: "027",
  COURSE_CATEGORY: "027/category/course",
  TRAINING_CATEGORY: "027/category/training",
  CERTIFICATE: "028",
  CONFIGURATION: "029",
  TAG: "030",
  TAG_TYPE: "031",
  NOTIFICATION_TEMPLATE: "033",
  ROLE_ASSIGNMENT: "034",
  BREACH_RECORD: "036",
  COMPANY: "037",
  ADVERTISEMENT: "040",
  REGISTRATION_QR: "041",
  IMPORT_BATCH: "042",
  IMPORT_ENTRY: "043",
  BLACKLIST: "044",
  PRODUCT: "443",
  PRODUCT_CATEGORY: "447",
  ORDER_MANAGEMENT: "435",
};

export const ACTIONS = {
  READ: "read",
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
};

export const LEVELS = {
  ORGANIZATION: "organization",
  COMPANY: "company",
  SITE: "site",
};

export const MANDATORY_PERMISSIONS = [
  {
    module: RESOURCES.AUTH,
    actions: [ACTIONS.READ],
  },
  {
    module: RESOURCES.ORGANIZATION,
    actions: [ACTIONS.READ],
  },
  {
    module: RESOURCES.CONFIGURATION,
    actions: [ACTIONS.READ],
  },
  {
    module: RESOURCES.COMPANY,
    actions: [ACTIONS.READ],
  },
  {
    module: RESOURCES.ADMIN_USER_GROUP,
    actions: [ACTIONS.READ],
  },
];
